import React, { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { FilterValue } from 'react-table';
import { debounce } from 'debounce';

import { useSelector, useDispatch } from '../../../redux/hooks';
import { fetchResults } from '../../../redux/slices/search/search';
import * as styles from './styles/styles.module.scss';

type TrailNameFilterProps = {
  column: {
    filterValue: string;
    setFilter: (filterValue: FilterValue) => FilterValue;
  };
};

const TrailNameFilter = ({ column: { filterValue, setFilter } }: TrailNameFilterProps): JSX.Element => {
  const dispatch = useDispatch();
  const searchEnabled = useSelector(state => state.enabledFeatures.search);
  const { groups, primaryAlgoliaIndexId } = useSelector(
    ({ authState }) => ({
      groups: authState.groups,
      primaryAlgoliaIndexId: authState.primaryAlgoliaIndexId
    }),
    shallowEqual
  );
  const search = useCallback(
    debounce((query: string) => {
      dispatch(fetchResults({ indexId: primaryAlgoliaIndexId, query, groups }));
    }, 500),
    [primaryAlgoliaIndexId, groups]
  );
  const onChange = useCallback(
    e => {
      const query = e.target.value;
      setFilter(query || undefined);
      if (searchEnabled) {
        search(query);
      }
    },
    [setFilter, searchEnabled, search]
  );

  return (
    <div className={styles.wrapper}>
      <input className={styles.input} value={filterValue || ''} onChange={onChange} placeholder="Enter a trail name" />
      <div className={styles.icon} />
    </div>
  );
};

export default TrailNameFilter;
